"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.acquireFileFromDropbox = acquireFileFromDropbox;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _I18n = _interopRequireDefault(require("I18n"));

var FileApi = _interopRequireWildcard(require("../api/Files"));

var _Constants = require("../Constants");

var _ActionTypes = require("./ActionTypes");

function acquireFileFromDropbox(file, folder, uploadedFileAccess) {
  return function (dispatch, getState, httpClient) {
    var fileDownloadOptions = {
      url: file.link,
      name: file.name
    };

    if (folder) {
      fileDownloadOptions.folderId = folder.get('id');
    }

    dispatch({
      type: _ActionTypes.DOWNLOAD_FROM_DROPBOX_ATTEMPTED,
      status: _Constants.RequestStatus.PENDING,
      meta: (0, _defineProperty2.default)({}, _Constants.TRACK_EVENT, {
        name: 'Manage Files',
        eventKey: 'fileManagerManageFiles',
        action: 'upload-dropbox-attempt'
      })
    });
    return FileApi.downloadFromUrl(fileDownloadOptions, file.link, uploadedFileAccess, httpClient).then(function (data) {
      dispatch({
        type: _ActionTypes.DOWNLOAD_FROM_DROPBOX_SUCCEEDED,
        status: _Constants.RequestStatus.SUCCEEDED,
        file: data,
        meta: (0, _defineProperty2.default)({}, _Constants.TRACK_EVENT, {
          name: 'Manage Files',
          eventKey: 'fileManagerManageFiles',
          action: 'upload-dropbox-success'
        })
      });
    }).catch(function (data) {
      var message = _I18n.default.text('FileManagerCore.notifications.upload.error.message', {
        filename: name
      });

      dispatch({
        type: _ActionTypes.DOWNLOAD_FROM_DROPBOX_FAILED,
        status: _Constants.RequestStatus.FAILED,
        meta: {
          notification: {
            type: 'danger',
            titleText: _I18n.default.text('FileManagerCore.notifications.upload.error.title'),
            message: message
          },
          error: data
        }
      });
    });
  };
}